export const ORG_TYPE_URL_SEGMENTS_BY_LOCALE = {
  en: [
    'nonprofit',
    'government',
    'consultant',
    'social-enterprise',
    'recruiter',
    'business',
    'community',
  ],
  es: [
    'ong',
    'gobierno',
    'consultor',
    'empresa-social',
    'agencia-de-contratacion',
    'empresa',
    'colectivo-ciudadano',
  ],
  pt: [
    // 'ong', already in es
    'governo',
    'consultoria',
    'empreendedorismo-social',
    'recrutador',
    // 'empresa', already in es
    'coletivos',
  ],
} as const satisfies Record<UserLocale, readonly string[]>;

export const ORG_TYPE_URL_SEGMENTS = Object.values(
  ORG_TYPE_URL_SEGMENTS_BY_LOCALE,
).flat();

export const JOB_URL_SEGMENTS_BY_LOCALE = {
  en: 'job',
  es: 'empleo',
  pt: 'emprego',
} as const satisfies Record<UserLocale, string>;

export const JOB_URL_SEGMENTS = Object.values(JOB_URL_SEGMENTS_BY_LOCALE);

export const combinedOrgTypeAndJobUrlSegments = ORG_TYPE_URL_SEGMENTS.flatMap(
  (orgTypeSegment) =>
    Object.values(JOB_URL_SEGMENTS).map(
      (jobUrlSegment) => `${orgTypeSegment}-${jobUrlSegment}`,
    ),
);

export const INTERNSHIP_URL_SEGMENTS_BY_LOCALE = {
  en: 'internship',
  es: 'pasantia',
  pt: 'estagio',
} as const satisfies Record<UserLocale, string>;

export const INTERNSHIP_URL_SEGMENTS = Object.values(
  INTERNSHIP_URL_SEGMENTS_BY_LOCALE,
);

export const combinedOrgTypeAndInternshipUrlSegments =
  ORG_TYPE_URL_SEGMENTS.flatMap((orgTypeSegment) =>
    Object.values(INTERNSHIP_URL_SEGMENTS).map(
      (internshipUrlSegment) => `${orgTypeSegment}-${internshipUrlSegment}`,
    ),
  );

export const VOLOP_URL_SEGMENTS_BY_LOCALE = {
  en: 'volunteer-opportunity',
  es: 'oportunidad-voluntariado',
  pt: 'oportunidade-voluntariado',
} as const satisfies Record<UserLocale, string>;

export const VOLOP_URL_SEGMENTS = Object.values(VOLOP_URL_SEGMENTS_BY_LOCALE);

export const GRAD_PROGRAM_URL_SEGMENTS_BY_LOCALE = {
  en: 'grad-program',
  es: 'programa-posgrado',
  pt: 'programa-posgraduacao',
} as const satisfies Record<UserLocale, string>;

export const GRAD_PROGRAM_URL_SEGMENTS = Object.values(
  GRAD_PROGRAM_URL_SEGMENTS_BY_LOCALE,
);
